import {
    createFromIconfontCN,
    VerticalLeftOutlined,
    VerticalRightOutlined,
    RedoOutlined,
    CloseOutlined,
    DownOutlined,
    LoadingOutlined,
    LockOutlined,
    MailOutlined,
    ArrowDownOutlined,
    ArrowUpOutlined,
    PlusOutlined,
    PoweroffOutlined,
    SearchOutlined,
    SettingOutlined,
    SmileTwoTone,
    UploadOutlined,
    UpOutlined,
    UserOutlined,
    CaretRightOutlined,
    IdcardOutlined,
    EditOutlined,
    DeleteOutlined,
    MessageOutlined,
    PieChartTwoTone,
    AccountBookTwoTone,
    FundTwoTone,
    BarsOutlined,
    HighlightOutlined,
    SelectOutlined,
    PhoneOutlined,
    MoneyCollectOutlined,
    FormOutlined,
    UpSquareOutlined,
    DownSquareOutlined,
    AppstoreOutlined,
    ExclamationCircleOutlined,
    CheckOutlined,
    ExclamationOutlined,
    HeartOutlined,
    HomeOutlined,
    CheckCircleOutlined,
    ForkOutlined,
    KeyOutlined,
    StarOutlined,
    RightCircleOutlined,
    LeftCircleOutlined,
    RightOutlined,
    ContainerOutlined,
    LeftOutlined,
    MinusOutlined
} from '@ant-design/icons-vue';

const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_989170_hp3iqkvxthc.js',
});

export default {
    RightCircleOutlined,
    LeftCircleOutlined,
    StarOutlined,
    CheckCircleOutlined,
    HomeOutlined,
    ExclamationOutlined,
    CheckOutlined,
    AppstoreOutlined,
    VerticalLeftOutlined,
    VerticalRightOutlined,
    RedoOutlined,
    IconFont,
    CloseOutlined,
    DownOutlined,
    LoadingOutlined,
    LockOutlined,
    MailOutlined,
    ArrowDownOutlined,
    ArrowUpOutlined,
    PlusOutlined,
    PoweroffOutlined,
    SearchOutlined,
    SettingOutlined,
    SmileTwoTone,
    UploadOutlined,
    UpOutlined,
    UserOutlined,
    CaretRightOutlined,
    IdcardOutlined,
    EditOutlined,
    DeleteOutlined,
    MessageOutlined,
    PieChartTwoTone,
    AccountBookTwoTone,
    FundTwoTone,
    BarsOutlined,
    HighlightOutlined,
    SelectOutlined,
    PhoneOutlined,
    MoneyCollectOutlined,
    FormOutlined,
    UpSquareOutlined,
    DownSquareOutlined,
    ExclamationCircleOutlined,
    HeartOutlined,
    ForkOutlined,
    KeyOutlined,
    RightOutlined,
    ContainerOutlined,
    LeftOutlined,
    MinusOutlined
}
